import React from "react";
import {IntlProvider} from "react-intl";
import TrialButton from "./Trial/button";
import {getCurrentTranslation} from "../utils/translations";
import PropTypes from "prop-types";

const Trial = ({config}) => {

    return (
        <IntlProvider messages={getCurrentTranslation(config.locale)} locale={config.locale} defaultLocale="cs">
            <TrialButton config={config} />
        </IntlProvider>
    );

}

Trial.propTypes = {
    config: PropTypes.object.isRequired
};

Trial.defaultProps = {}

export default Trial;
